import { useQuery } from '@tanstack/react-query';
import PlansService from '../../services/PlansService';

export const planKeys = {
  all: ['plans'],
  list: () => [...planKeys.all, 'list'],
};

export function usePlans() {
  return useQuery({
    queryKey: planKeys.list(),
    queryFn: () => PlansService.listPlans(),
  });
}
